// removed by extract-text-webpack-plugin
module.exports = {"footer":"Footer__footer___1lWZF","fixed":"Footer__fixed___1i7D2"};